import React, { useEffect } from "react";
import InputText from "../../../common/Input/InputText";
import { getAllLabReport } from "../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";
import Select from "react-select";
import InputDate from "../../../common/Input/InputDate";
const AssignedAndRemark = ({ labReportFormData, handleChange }) => {
  const dispatch = useDispatch();
  const { physician } = useSelector((state) => state.physician);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const labReportId = sessionStorage.getItem("labReportId");
  const clinicId = clinicInfo?.[0]?.clinicId || null;

  useEffect(() => {
    dispatch(getAllLabReport({ clinicId, id: labReportId, token }));
    dispatch(
      getAllPhysician({
        clinicId,
        specializationName: "Pathologist",
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      }),
    );
  }, [dispatch, clinicId, labReportId, token]);

  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Assigned and Remark</h4>
        <div className="row">
          <div className="col-xl-3">
            <label htmlFor="message-text" className="col-form-label mb-2">
              Select Physician
            </label>
            <Select
              name="assignedPhysician"
              placeholder="Select Physician"
              onChange={(e) => handleChange(e, "assignedPhysician")}
              value={{
                value: labReportFormData?.assignedPhysician,
                label: labReportFormData?.assignedPhysicianName,
              }}
              options={
                physician &&
                physician?.map((item) => ({
                  value: item._id,
                  label: item?.userId?.name,
                }))
              }
            />
          </div>

          <div className="col-xl-3">
            <InputDate
              name="assignDoctorDate"
              value={
                labReportFormData?.assignDoctorDate
                  ? new Date(labReportFormData.assignDoctorDate)
                      .toISOString()
                      .split("T")[0]
                  : ""
              }
              onChange={handleChange}
              placeholder="Assign Doctor Date"
            />
          </div>
          <div className="col-xl-3">
            <InputText
              name="remark"
              value={labReportFormData?.remark}
              onChange={(e) => handleChange(e)}
              label="Any Remark"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignedAndRemark;
